import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ISubscriptionDetails } from "../../interfaces";

export const useSubscriptionDetails = () => {
  return useQuery<ISubscriptionDetails, Error>({
    queryKey: ["stripe", "details"],
    queryFn: async () => {
      const response = await httpService.get<ISubscriptionDetails>(
        API_CONFIG.path.stripeDetails
      );
      return response;
    },
  });
};
